import { __assign, __extends } from "tslib";
import { create as createJss, SheetsRegistry, } from 'jss';
import jssPreset from '@material-ui/styles/jssPreset';
var jssInst = createJss(jssPreset());
var JssDomRendererConstructor = jssInst.options.Renderer;
function warning(message) {
    if (process.env.NODE_ENV !== 'production') {
        throw new Error(message);
    }
}
export default function JssDomRendererFactory(window, sheets) {
    var document = window.document;
    var getHead = function () { return document.head; };
    var findHigherSheet = function (registry, options) {
        for (var i = 0; i < registry.length; i++) {
            var sheet = registry[i];
            if (sheet.attached &&
                sheet.options.index > options.index &&
                sheet.options.insertionPoint === options.insertionPoint) {
                return sheet;
            }
        }
        return null;
    };
    var findHighestSheet = function (registry, options) {
        for (var i = registry.length - 1; i >= 0; i--) {
            var sheet = registry[i];
            if (sheet.attached &&
                sheet.options.insertionPoint === options.insertionPoint) {
                return sheet;
            }
        }
        return null;
    };
    var findPrevNode = function (options) {
        // @ts-ignore
        var registry = sheets.registry;
        if (registry.length > 0) {
            // Try to insert before the next higher sheet.
            var sheet = findHigherSheet(registry, options);
            if (sheet && sheet.renderer) {
                return {
                    parent: sheet.renderer.element.parentNode,
                    node: sheet.renderer.element,
                };
            }
            // Otherwise insert after the last attached.
            sheet = findHighestSheet(registry, options);
            if (sheet && sheet.renderer) {
                return {
                    parent: sheet.renderer.element.parentNode,
                    node: sheet.renderer.element.nextSibling,
                };
            }
        }
        // Try to find a comment placeholder if registry is empty.
        var insertionPoint = options.insertionPoint;
        if (insertionPoint && typeof insertionPoint === 'string') {
            var comment = findCommentNode(insertionPoint);
            if (comment) {
                return {
                    parent: comment.parentNode,
                    node: comment.nextSibling,
                };
            }
            // If user specifies an insertion point and it can't be found in the document -
            // bad specificity issues may appear.
            warning("[JSS] Insertion point \"" + insertionPoint + "\" not found.");
        }
        return false;
    };
    /**
     * Find a comment with "jss" inside.
     */
    function findCommentNode(text) {
        var _a;
        var head = getHead();
        for (var i = 0; i < head.childNodes.length; i++) {
            var node = head.childNodes[i];
            if (node.nodeType === 8 && ((_a = node.nodeValue) === null || _a === void 0 ? void 0 : _a.trim()) === text) {
                return node;
            }
        }
        return null;
    }
    var insertStyle = function (style, options) {
        var insertionPoint = options.insertionPoint;
        var nextNode = findPrevNode(options);
        if (nextNode !== false && nextNode.parent) {
            nextNode.parent.insertBefore(style, nextNode.node);
            return;
        }
        // Works with iframes and any node types.
        if (typeof insertionPoint !== 'string' &&
            insertionPoint &&
            typeof insertionPoint.nodeType === 'number') {
            var insertionPointElement = insertionPoint;
            var parentNode = insertionPointElement.parentNode;
            if (parentNode)
                parentNode.insertBefore(style, insertionPointElement.nextSibling);
            else
                warning('[JSS] Insertion point is not in the DOM.');
            return;
        }
        getHead().appendChild(style);
    };
    var createStyle = function () {
        var el = document.createElement('style');
        el.textContent = '\n';
        return el;
    };
    var getNonce = function () {
        var node = document.querySelector('meta[property="csp-nonce"]');
        return node ? node.getAttribute('content') : null;
    };
    return /** @class */ (function (_super) {
        __extends(ExternalJssDomRenderer, _super);
        function ExternalJssDomRenderer(sheet) {
            var _this = _super.call(this) || this;
            // We don't want sheet added to another sheet registry in super class
            // this may cause memory leak
            // and then, we need do same work as super class constructor
            _this.sheet = sheet;
            if (sheet) {
                sheets.add(sheet);
            }
            _this.element = (sheet === null || sheet === void 0 ? void 0 : sheet.options.element) || createStyle();
            _this.element.setAttribute('data-jss', '');
            if (sheet === null || sheet === void 0 ? void 0 : sheet.options.media) {
                _this.element.setAttribute('media', sheet.options.media);
            }
            if (sheet === null || sheet === void 0 ? void 0 : sheet.options.meta) {
                _this.element.setAttribute('data-meta', sheet.options.meta);
            }
            var nonce = getNonce();
            if (nonce)
                _this.element.setAttribute('nonce', nonce);
            return _this;
        }
        ExternalJssDomRenderer.prototype.attach = function () {
            if (this.element.parentNode || !this.sheet)
                return;
            insertStyle(this.element, this.sheet.options);
        };
        return ExternalJssDomRenderer;
    }(JssDomRendererConstructor));
}
export function buildJssFromWindow(targetWindow, 
/**
 * custom jss option
 */
options) {
    // jss use global sheetsRegistry internally, but in our usecase, we need stand alone sheetsRegistry
    // we change jss behavior by patch-pacakge jss, will try to submit pr to jss repo later
    var sheetsRegistry = new SheetsRegistry();
    return createJss(__assign(__assign(__assign({}, jssPreset()), options), { 
        // @ts-ignore
        sheetsRegistry: sheetsRegistry, Renderer: JssDomRendererFactory(targetWindow, sheetsRegistry) }));
}
